import { QueryParams } from '@heda/core-util';

export class MessageLog {
  id: string;
  type: string;
  date: Date;
  status: string;
  receiver: string;
  metadata: string;
  expiresAt: Date;
  message: string;
  response: string;
}

export class MessageLogSearchParams extends QueryParams {
  dateTo?: Date;
  dateFrom?: Date;
  type?: string;
  status?: string;
  receiver?: string;
  content?: string;
}
